function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.18825 23.8372C5.8073 24.5039 6.28867 25.3334 7.05649 25.3334L24.9435 25.3334C25.7113 25.3334 26.1927 24.5039 25.8117 23.8372L16.8682 8.18613C16.4843 7.51432 15.5156 7.51432 15.1317 8.18613L6.18825 23.8372Z",
  fill: "#F9C45C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 23.1614C16.619 23.1614 17.1226 22.6575 17.1226 22.0381C17.1226 21.4192 16.619 20.9158 16 20.9158C15.381 20.9158 14.8774 21.4192 14.8774 22.0381C14.8774 22.6575 15.381 23.1614 16 23.1614Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9999 19.2316C16.465 19.2316 16.842 18.8545 16.842 18.3894L16.842 13.3368C16.842 12.8717 16.465 12.4947 15.9999 12.4947C15.5348 12.4947 15.1578 12.8717 15.1578 13.3368L15.1578 18.3894C15.1578 18.8545 15.5348 19.2316 15.9999 19.2316Z",
  fill: "white"
});

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.19b28269.svg";
export { ForwardRef as ReactComponent };